import ShippingPage from '../../components/ShippingPage';
import ShippingRestrictionForm from '../components/ShippingRestrictionForm';
import { useShippingRestrictionPage } from '../hooks';

function EditShippingRestrictionPage(): JSX.Element {
  const {
    values,
    handleOnSubmit,
    handleChange,
    setFieldValue,
    errors,
    isUpdating,
    isError,
    title,
    currentRestrictionId,
    showSkeleton,
  } = useShippingRestrictionPage({ mode: 'edit' });

  return (
    <ShippingPage
      title={title}
      handleSave={handleOnSubmit}
      isUpdating={isUpdating}
      isError={isError}
      isLoading={showSkeleton}
    >
      {!isError && !showSkeleton && (
        <ShippingRestrictionForm
          values={values}
          onChange={handleChange}
          onArrayChange={setFieldValue}
          errors={errors}
          currentRestrictionId={currentRestrictionId}
        />
      )}

      {showSkeleton && <ShippingRestrictionForm.Skeleton />}
    </ShippingPage>
  );
}

export default EditShippingRestrictionPage;
